exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#keyboard[data-v-11ef176b]{margin:30px 8px 0;user-select:none}.row[data-v-11ef176b]{display:flex;width:100%;margin:0 auto 8px;touch-action:manipulation}.spacer[data-v-11ef176b]{flex:0.5}button[data-v-11ef176b]{font-family:inherit;font-weight:700;border:0;padding:0;margin:0 6px 0 0;height:58px;border-radius:4px;cursor:pointer;user-select:none;background-color:#d3d6da;color:#1a1a1b;flex:1;display:flex;justify-content:center;align-items:center;text-transform:uppercase;-webkit-tap-highlight-color:rgba(0,0,0,.3);transition:all .2s 1.5s}button[data-v-11ef176b]:last-of-type{margin:0}button.big[data-v-11ef176b]{flex:1.5}", ""]);

// exports
